module.exports = __webpack_public_path__ + "static/media/sf-trial-1.09f9854d.mp3";